import { useState } from "react"

export default function useMultipleForm(node) {
  const [selectedIndex, setSelectedIndex] = useState(0)

  function next() {
    setSelectedIndex((prev) => (prev >= node.length - 1 ? prev : prev + 1))
  }

  function prev() {
    setSelectedIndex((prev) => (prev <= 0 ? prev : prev - 1))
  }

  function get(index) {
    setSelectedIndex(index)
  }

  return {
    selectedIndex,
    currentNode: node[selectedIndex],
    next,
    prev,
    get,
  }
}
